import React from "react";
import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import { styled } from "@mui/system";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const SectionContainer = styled(Box)({
  width: "100%",
  minHeight: "50vh",
  background: "linear-gradient(to top right, #101217, #323640)",
  color: "white",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "1em 0",
  margin: "auto",
});

const Block = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "30vw",
  borderLeft: "2px solid rgb(138, 138, 138)",
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  textAlign: "justify",
  padding: theme.spacing(4),
  gap: theme.spacing(4),
  wordWrap: "break-word",
}));

const BlockImage = styled("img")(({ theme }) => ({
  width: "5vw",
  height: "5vw",
  [theme.breakpoints.down("sm")]: {
    width: "4em",
    height: "4em",
  },
}));

const Section_2 = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md")); // below 960px
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // below 600px

  const blocks = [
    {
      imgSrc: "assets/section-2-small-png-1.png",
      title: "Reliable Experts",
      text: "Our experienced team delivers every project with skill and care. We’re known for doing things right the first time — on time, every time. You can trust us to handle it all, hassle-free.",
    },
    {
      imgSrc: "assets/lic-cont-sec-2.png",
      title: "Licensed Contractor",
      text: "We’re fully licensed and follow all safety and building codes. That means your project is in professional, certified hands from start to finish. No shortcuts — just solid work you can rely on.",
    },
    {
      imgSrc: "assets/Quality-section-2-2.png",
      title: "Quality Guaranteed",
      text: "We don’t just build — we build to last. From materials to finishes, everything meets the highest standards. Your satisfaction isn’t just expected — it’s guaranteed",
    },
  ];

  return (
    <SectionContainer>
      {isTablet ? (
        // Mobile/Tablet: Show Swiper
        <Swiper
          spaceBetween={30}
          slidesPerView={1}
          style={{ width: "90%", paddingBottom: "2em" }}
        >
          {blocks.map((block, index) => (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  borderLeft: "2px solid rgb(138, 138, 138)",
                  p: 3,
                  textAlign: "start",
                }}
              >
                <BlockImage src={block.imgSrc} alt={block.title} />
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  fontSize="5vw"
                  mt={2}
                >
                  {block.title}
                </Typography>
                <Typography fontSize="3.5vw">{block.text}</Typography>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        // Desktop: Show Grid
        <Grid
          container
          rowSpacing={8}
          justifyContent="center"
          className="section-2-exportcss-for-padding"
          sx={{
            maxWidth: {
              xs: "80%",
              sm: "95%",
              md: "90%",
              lg: "90%",
              xl: "100%",
            },
            pl: 0,
            mx: "auto",
          }}
        >
          {blocks.map((block, index) => (
            <Grid item xs={24} sm={6} md={4} key={index}>
              <Block sx={{ p: 0, pl: 4, margin: "auto" }}>
                <BlockImage src={block.imgSrc} alt={block.title} />
                <Typography
                  variant="h3"
                  fontSize="1.8vw"
                  fontWeight="bold"
                  textAlign="start"
                >
                  {block.title}
                </Typography>
                <Typography variant="body1" fontSize="1vw" textAlign="start">
                  {block.text}
                </Typography>
              </Block>
            </Grid>
          ))}
        </Grid>
      )}
    </SectionContainer>
  );
};

export default Section_2;
